import { Component, OnDestroy } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

export interface InfoHeaderParams extends IHeaderParams {
  tooltipText: string;
}

@Component({
  selector: 'app-info-header',
  standalone: true,
  imports: [NgbTooltip],
  templateUrl: './info-header.component.html',
  styleUrls: ['./info-header.component.scss']
})
export class InfoHeaderComponent implements IHeaderAngularComp, OnDestroy {
  params!: InfoHeaderParams;
  sortState: 'asc' | 'desc' | null = null;

  agInit(params: InfoHeaderParams): void {
    this.params = params;
    this.params.column.addEventListener('sortChanged', this.sortChangedListener);
    this.onSortChanged();
  }

  ngOnDestroy(): void {
    this.params?.column?.removeEventListener('sortChanged', this.sortChangedListener);
  }

  onSortChanged(): void {
    const sort = this.params.column.getSort();
    if (sort === 'asc') {
      this.sortState = 'asc';
    } else if (sort === 'desc') {
      this.sortState = 'desc';
    } else {
      this.sortState = null;
    }
  }

  onSortRequested(event: MouseEvent): void {
    let nextSort: 'asc' | 'desc' | null;
    if (this.sortState === null) {
      nextSort = 'asc';
    } else if (this.sortState === 'asc') {
      nextSort = 'desc';
    } else {
      nextSort = null;
    }
    this.params.setSort(nextSort, event.shiftKey);
  }

  refresh(params: InfoHeaderParams): boolean {
    this.params = params;
    this.onSortChanged();
    return true;
  }

  private readonly sortChangedListener = () => this.onSortChanged();
}
